import baseLogic from '../backboneUser/willCreate_identity_backboneUser';
import { constants } from 'lib_ui-services';

export default {
    ...baseLogic,
    relation: 'user',
    useCaseIds: [constants.useCaseIds.FREIGHT_RUNNER]
};
